import { Fragment, useMemo, useState } from 'react'

import { IconZoomIn } from '@tabler/icons-react'
import { Image } from 'antd'
import styled from 'styled-components'

const MiniImage = styled(Image).attrs({ width: '30px', height: '30px' })`
  object-fit: cover;
  object-position: center;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.colour.neutral.white};
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
`

const MiniImageTilt = styled(MiniImage)`
  transform: rotate(6deg);
  transform-origin: bottom center;
  transition: transform 0.3s ease;
`

const Wrapper = styled.div`
  position: relative;
  display: inline-block; // allow the column 'align' to worker

  &:hover {
    & ${MiniImageTilt} {
      transform: rotate(16deg);
    }
  }
`

export type TableAttachment = {
  url: string
  thumbailUrl?: string
  alt: string
}

type Props = {
  attachments: TableAttachment[]
}

export const AttachmentTablePreview: React.FC<Props> = ({ attachments }) => {
  const [errorUrls, setErrorUrls] = useState<string[]>([])

  const sanitisedAttachments = useMemo(() => {
    return attachments.filter((a) => !errorUrls.includes(a.url))
  }, [attachments, errorUrls])

  if (!sanitisedAttachments?.length) return null

  return (
    <Image.PreviewGroup>
      <Wrapper>
        {sanitisedAttachments.map((a, i) => {
          if (i === 1) {
            return (
              <MiniImageTilt
                key={a.url}
                src={a.thumbailUrl ?? a.url}
                alt={a.alt}
                preview={{ src: a.url, mask: <Fragment /> }}
                onError={() => setErrorUrls((ids) => [...ids, a.url])}
                wrapperStyle={{
                  position: 'absolute',
                  top: '-2px',
                  left: '8px',
                  zIndex: 1,
                }}
              />
            )
          }

          return (
            <MiniImage
              key={a.url}
              src={a.thumbailUrl ?? a.url}
              alt={a.alt}
              preview={{ src: a.url, mask: <IconZoomIn size={14} /> }}
              wrapperStyle={{ display: i === 0 ? 'block' : 'none', zIndex: 2 }}
              onError={() => setErrorUrls((ids) => [...ids, a.url])}
            />
          )
        })}
      </Wrapper>
    </Image.PreviewGroup>
  )
}
